import { Button, ButtonSize, ButtonTheme } from "@redotech/redo-web/button";
import { memo } from "react";
import * as questions from "../choose-items.module.css";
import { ChooseVariantFooter } from "./variant-exchange";

export const VariantExchangeFooter: ChooseVariantFooter = memo(
  function VariantExchangeFooter({ enabled, onSubmit, onBack }) {
    return (
      <>
        <Button
          className={questions.optionButton}
          onClick={onBack}
          size={ButtonSize.MEDIUM}
          theme={ButtonTheme.OUTLINED}
        >
          Return another way
        </Button>
        <Button
          className={questions.optionButton}
          disabled={!enabled}
          onClick={onSubmit}
          size={ButtonSize.MEDIUM}
          theme={ButtonTheme.PRIMARY}
        >
          Save exchange selection
        </Button>
      </>
    );
  },
);
